import mod from "-!./tooltip.ts?vue&type=script&lang=ts&"; export default mod; export * from "-!./tooltip.ts?vue&type=script&lang=ts&"